import { Box, Typography } from "@mui/material";
import React from "react";

export default function Number({ number, children }) {
  return (
    <Box sx={{ display: "flex", pl: 1, pt: 1 }}>
      <Typography fontWeight="bold">{number}.</Typography>
      <Typography sx={{ pl: 1, lineHeight: 1.8 }}>{children}</Typography>
    </Box>
  );
}
